import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconClose(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <path
        d="M4.292 2.375 2.375 4.292 14.083 16 2.375 27.708l1.917 1.917L16 17.917l11.708 11.708 1.917-1.917L17.917 16 29.625 4.292l-1.917-1.917L16 14.083 4.292 2.375z"
        fill="currentColor"
      />
    </Icon>
  );
}
